
import Vue from 'vue'

import store from './store'


import '@/assets/css/custom.scss';

import '@/assets/css/spinner.scss';

import '@/assets/css/animation.scss';

import '@/assets/css/animation-custom.scss';

import '@/assets/css/tailwind.scss';


store.commit('setRecaptchaSitekey', window.env.recaptcha.sitekey || false);


import PortalVue from 'portal-vue'

Vue.use(PortalVue)


import Vuelidate from 'vuelidate'

Vue.use(Vuelidate)


import VaModal from '@/components/VaModal.vue'

Vue.component('VaModal', VaModal)


import Spinner from '@/components/Spinner.vue'

Vue.component('Spinner', Spinner)


import SvgClose from '@/components/SvgClose.vue'

Vue.component('SvgClose', SvgClose)


import FastClick from 'fastclick'

FastClick.attach(document.body);


function scrollToTop(scrollDuration, topOffset) {

  scrollDuration = scrollDuration || 500;

  topOffset = parseInt(topOffset || 0, 10);

  var scrollStep = -window.scrollY / (scrollDuration / 15);
  var scrollIntr = setInterval(function() {

    if ( window.scrollY > topOffset ) {
      window.scrollBy( topOffset, scrollStep );
    } else {
      clearInterval(scrollIntr);
    }

  }, 15);
}

window.scrollToTop = window.scrollToTop || scrollToTop;

window.env = window.env || {};

// Easy access to the querystring params
let qs = function() {

    // Using the npm url-parse library
    const urlparse = require('url-parse');

    let x = {
        parts: urlparse(location, true)
    };

    // All query params
    let o = {
        query: x.parts.query
    };

    // Does the key exist
    o.has = function(key) {
        return o.query[key] !== undefined;
    };

    // Get the key value
    o.get = function(key) {
        return o.query[key] || '';
    };

    return o;
};

window.qs = window.qs || new qs();

// Adjust the html font-size to the value of querystring "fs"
// (the general app font size will scale accordingly)
// eg: ?fs=10 (font-size: 10px)
// eg: ?fs=12 (font-size: 12px)
// eg: ?fs=14 (font-size: 14px) <- default
let fs = window.qs.has('fs') ? parseInt(window.qs.get('fs'), 10) : 0;

if (fs) { document.querySelector('html').style.fontSize = fs + 'px'; }

// Use to confirm before leaving site
// window.onbeforeunload = s => "";
// window.addEventListener('beforeunload', function (e) {
//   // Cancel the event
//   e.preventDefault();
//   // Chrome requires returnValue to be set
//   e.returnValue = '';
// });
